/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.button {
  border-radius: var(--radius-sm, 0.25rem);
  background-color: var(--color-white, #fff);
  width: 100%;
  height: 100%;
}
.size-md {
  width: calc(var(--spacing, 0.25rem) * 12);
  height: calc(var(--spacing, 0.25rem) * 12);
}
.size-sm {
  width: calc(var(--spacing, 0.25rem) * 8);
  height: calc(var(--spacing, 0.25rem) * 8);
}
.size-xs {
  width: calc(var(--spacing, 0.25rem) * 6);
  height: calc(var(--spacing, 0.25rem) * 6);
}
.button:hover {
  background-color: var(--color-gray-100, #f5f5f5);
}
.button[aria-expanded="true"], .buttonSelected {
  border-style: var(--tw-border-style);
  border-width: 1px;
  --tw-border-style: solid;
  border-style: solid;
  border-color: var(--color-primary-500);
  background-color: var(--color-primary-100);
}
.container {
  background-color: var(--color-white, #fff);
  display: flex;
  align-items: center;
  justify-content: center;
}
.stickyRight {
  position: sticky;
  right: 0px;
}
[data-selected="true"] .button, .isSelected {
  background-color: var(--color-primary-100);
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
    }
  }
}
